import React from 'react';

import { useSSRPlaceholderReplaceIdProp } from '@confluence/loadable';

// ssrPlaceholderReplaceIdProp is added to LOADABLE AFTER_PAINT priority elements to identify and exclude them
// from TTVC calculations if their size and position doesn't change after hydration

// Simplified wrapper - engagement functionality disabled
export const EngagementInlineDialogWrapper = (props: any): React.JSX.Element => {
	const ssrPlaceholderIdProp = useSSRPlaceholderReplaceIdProp();

	// there are multiple engagement inline dialog loaders used for navigation, so we're using
	// dataVC to distinguish for reporting
	const { children, dataVC, ...restProps } = props;
	return (
		<div {...restProps}>
			<div data-vc={dataVC} {...ssrPlaceholderIdProp}>
				{children}
			</div>
		</div>
	);
};
